// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as Constants$DvmAdminFrontendFr from "../../../../../../common/Constants.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../../../../common/utils/Utils_Alert.bs.js";
import * as Messages_File_Upload$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_File_Upload.bs.js";

function Order_Detail_Bonus_DealerRequest_FileUpload_Button(Props) {
  var addFile = Props.addFile;
  var alert = ReactAlert.useAlert();
  return React.createElement(React.Fragment, undefined, React.createElement("input", {
                  id: "contained-button-file",
                  style: {
                    display: "none"
                  },
                  accept: ".pdf",
                  type: "file",
                  value: "",
                  onChange: (function ($$event) {
                      var file = Belt_Array.get($$event.currentTarget.files, 0);
                      if (file !== undefined) {
                        if (file.size > Constants$DvmAdminFrontendFr.maxFileSize) {
                          return Utils_Alert$DvmAdminFrontendFr.info(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                                          message: {
                                            TAG: /* Message */0,
                                            _0: Messages_File_Upload$DvmAdminFrontendFr.fileTooLarge
                                          }
                                        }));
                        } else {
                          return Curry._1(addFile, file);
                        }
                      }
                      
                    })
                }), React.createElement("label", {
                  htmlFor: "contained-button-file"
                }, React.createElement(Core.Button, {
                      children: "+",
                      color: "primary",
                      component: "span",
                      size: "medium",
                      variant: "contained"
                    })));
}

var make = Order_Detail_Bonus_DealerRequest_FileUpload_Button;

export {
  make ,
}
/* react Not a pure module */
